import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './CTA.css';

const CTA = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setEmail('');
    }
  };

  return (
    <section className="cta">
      <div className="cta__background">
        <div className="cta__shape cta__shape--1"></div>
        <div className="cta__shape cta__shape--2"></div>
        <div className="cta__shape cta__shape--3"></div>
      </div>
      
      <div className="cta__container">
        <div className="cta__content">
          <h2 className="cta__title">
            {t('cta.title')}
          </h2>
          <p className="cta__subtitle">
            {t('cta.subtitle')}
          </p>
          
          {!isSubmitted ? (
            <form className="cta__form" onSubmit={handleSubmit}>
              <div className="cta__input-wrapper">
                <svg className="cta__input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <input
                  type="email"
                  className="cta__input"
                  placeholder={t('cta.emailPlaceholder')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="cta__button">
                {t('cta.signUp')}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.167 10h11.666M10 4.167L15.833 10 10 15.833" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </form>
          ) : (
            <div className="cta__success">
              <svg className="cta__success-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{t('cta.success')}</span>
            </div>
          )}
          
          <p className="cta__note">
            {t('cta.note')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default React.memo(CTA);
